import pieChart from './pieChart';

export default pieChart;
